import AsyncStorage from '@react-native-async-storage/async-storage';

import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export type WhatsNewStore = {
    seenCardIds: string[];
    isLobbyReady: boolean;
    _hydrated: boolean;
    actions: {
        markCardSeen: (cardId: string) => void;
        markCardsSeen: (cardIds: string[]) => void;
        unmarkCard: (cardId: string) => void;
        resetAll: () => void;
        setLobbyReady: (ready: boolean) => void;
        setHydrated: () => void;
    };
};

export const useWhatsNewStore = create<WhatsNewStore>()(
    persist(
        set => ({
            seenCardIds: [],
            isLobbyReady: false,
            _hydrated: false,
            actions: {
                markCardSeen: cardId =>
                    set(state => {
                        if (state.seenCardIds.includes(cardId)) return state;
                        return { seenCardIds: [...state.seenCardIds, cardId] };
                    }),
                markCardsSeen: cardIds =>
                    set(state => ({ seenCardIds: [...new Set([...state.seenCardIds, ...cardIds])] })),
                unmarkCard: cardId => set(state => ({ seenCardIds: state.seenCardIds.filter(id => id !== cardId) })),
                resetAll: () => set({ seenCardIds: [] }),
                setLobbyReady: ready => set({ isLobbyReady: ready }),
                setHydrated: () => set({ _hydrated: true }),
            },
        }),

        {
            name: 'whats-new-storage',
            version: 5,
            storage: createJSONStorage(() => AsyncStorage),
            partialize: ({ actions: _actions, isLobbyReady: _isLobbyReady, _hydrated, ...rest }: WhatsNewStore) => rest,
            onRehydrateStorage: () => store => {
                store?.actions.setHydrated();
            },
        }
    )
);
